import { prefersReducedMotion } from "@bitwarden/web-vault/app/shared/utils/reduced-motion.util";

/**
 * Page-switch reveal (GLOSS nav transition, "youtube" preset): content slides up from 24px
 * below while fading in. No spinner in between; the duration is stretched so the motion reads.
 */
const PAGE_ENTER_DURATION_MS = 600;
const PAGE_ENTER_OFFSET_PX = 24;
const PAGE_ENTER_EASING = "cubic-bezier(.23,1,.32,1)";
const PAGE_ENTER_REDUCED_DURATION_MS = 150;
const PAGE_ENTER_ANIMATION_ID = "page-enter";

/**
 * Plays the page-enter reveal on each element, cancelling any reveal still running on it.
 * `fill: "backwards"` drops the transform once finished, so `position: fixed` descendants
 * are only offset for the duration of the reveal.
 */
export function playPageEnterAnimation(elements: (HTMLElement | null | undefined)[]): void {
  const reduced = prefersReducedMotion();
  const keyframes: Keyframe[] = reduced
    ? [{ opacity: 0 }, { opacity: 1 }]
    : [
        { opacity: 0, transform: `translateY(${PAGE_ENTER_OFFSET_PX}px)` },
        { opacity: 1, transform: "translateY(0)" },
      ];

  for (const element of elements) {
    // `animate` is missing in jsdom.
    if (!element || typeof element.animate !== "function") {
      continue;
    }
    element.getAnimations?.().forEach((animation) => {
      if (animation.id === PAGE_ENTER_ANIMATION_ID) {
        animation.cancel();
      }
    });
    element.animate(keyframes, {
      id: PAGE_ENTER_ANIMATION_ID,
      duration: reduced ? PAGE_ENTER_REDUCED_DURATION_MS : PAGE_ENTER_DURATION_MS,
      easing: PAGE_ENTER_EASING,
      fill: "backwards",
    });
  }
}
